import { Controller } from "@hotwired/stimulus"

// Phase 2.6 Tier 1 — Risk Categories admin. Handles the delete confirm
// modal so we don't fall back to browser `confirm()` per CLAUDE.md.
export default class extends Controller {
  static targets = [
    "deleteModal",
    "deleteForm",
    "deleteName"
  ]

  openDelete(event) {
    event && event.preventDefault()
    if (!this.hasDeleteModalTarget) return

    const t = event.currentTarget
    if (this.hasDeleteFormTarget) {
      this.deleteFormTarget.action = t.dataset.deleteUrl || ""
    }
    if (this.hasDeleteNameTarget) {
      this.deleteNameTarget.textContent = t.dataset.deleteName || ""
    }
    this.deleteModalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  closeDelete(event) {
    event && event.preventDefault()
    if (this.hasDeleteModalTarget) {
      this.deleteModalTarget.classList.add("hidden")
    }
    document.body.style.overflow = ""
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
